import { StackView, Box, Paragraph, ChevronLink } from '@telus-uds/components-web'
import { object, bool, func } from 'prop-types'

import useTranslate from '../../../../hooks/useTranslate'

import { isReserveInStoreEligible } from './utils'

const ReserveInStore = ({ isCartValid, cart, triggerFulfillment }) => {
  const translate = useTranslate()

  if (!isCartValid) {
    return null
  }
  if (!isReserveInStoreEligible(cart)) {
    return null
  }

  const handleClick = (e) => {
    e.preventDefault()
    triggerFulfillment({
      method: 'IN_STORE',
      deferPayment: true
    })
  }
  return (
    <StackView space={2}>
      <Box bottom={3}>
        <Paragraph align="center">
          <ChevronLink testID="price-summary-reserve-in-store-cta" href="#" onPress={handleClick}>
            {translate('priceSummary.reserveInStore')}
          </ChevronLink>
        </Paragraph>
      </Box>
    </StackView>
  )
}

ReserveInStore.propTypes = {
  isCartValid: bool.isRequired,
  triggerFulfillment: func.isRequired,
  cart: object.isRequired
}
export default ReserveInStore
